import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import AbpBackend from './AbpBackend';
import { DEFAULT_LANGUAGE, RESOURCE_NAME, STORAGE_KEY } from './constants';

i18n
  .use(AbpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: RESOURCE_NAME,
    ns: [RESOURCE_NAME],
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    pluralSeparator: '_',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
